import { useSyncExternalStore } from 'react'
import {
  getPlacedTemplateIdSnapshot,
  subscribeTemplatePlacement,
} from '@/lib/templates/template-placement-session'

/** The template whose gallery card is highlighted on the spread on screen, or null. */
export function usePlacedTemplateId(): string | null {
  return useSyncExternalStore(
    subscribeTemplatePlacement,
    getPlacedTemplateIdSnapshot,
    getPlacedTemplateIdSnapshot
  )
}
